import { useStore } from "hooks/use-store";
import { useTranslation } from "react-i18next";
import RadioGroup from "components/ui/radio-group";
import { useLocalStorage } from "hooks/use-local-storage";
import { RpmSogMode } from "types/enums";

export const RpmSogToggle = () => {
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setLocalRpmSogMode] = useLocalStorage<RpmSogMode>(
    "rpm_sog_mode",
    RpmSogMode.Sog
  );

  const rpmSogMode = useStore((state) => state.rpmSogMode);
  const setRpmSogMode = useStore((state) => state.setRpmSogMode);

  const onRpmSogModeChange = (mode: RpmSogMode) => {
    setLocalRpmSogMode(mode);
    setRpmSogMode(mode);
  };

  return (
    <RadioGroup
      items={[
        {
          label: <p className="text-xl">{t("dashboard.sog")}</p>,
          value: RpmSogMode.Sog,
        },
        {
          label: <p className="text-xl">{t("dashboard.rpm")}</p>,
          value: RpmSogMode.Rpm,
        },
      ]}
      selected={rpmSogMode}
      setSelected={onRpmSogModeChange}
      name="eco-gauge-metric"
    />
  );
};
